import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapVoid } from './normalize'

// Sent without zoneIndex on purpose: only a full clear also soft-deletes the auto-generated
// sampling areas and unassigns their monitoring sites server-side.
export default async function deleteFarmClusters({ farmId }: { farmId: string }): Promise<void> {
  const response = await apiClient.delete(endpoints.v2.farms.clusters(farmId))
  return unwrapVoid(response)
}
